export const LoadingSkeleton = () => (
    <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-md rounded-xl shadow-xl p-6 border border-teal-500/10">
        <div className="md:flex gap-6">
            <div className="md:w-56 lg:w-64 mb-4 md:mb-0">
                <div className="h-52 md:h-full bg-gradient-to-br from-slate-700 to-slate-600 rounded-lg animate-pulse"></div>
            </div>
            <div className="flex-1 space-y-4">
                <div className="h-4 bg-gradient-to-r from-slate-700 to-transparent rounded-full w-1/4 animate-pulse"></div>
                <div className="h-7 bg-gradient-to-r from-slate-700 to-slate-600 rounded-lg w-full animate-pulse"></div>
                <div className="h-6 bg-gradient-to-r from-slate-700 to-slate-600 rounded-lg w-5/6 animate-pulse"></div>
                <div className="h-4 bg-gradient-to-r from-slate-700 to-transparent rounded-lg w-4/5 animate-pulse"></div>
                <div className="pt-4 flex justify-between items-center">
                    <div className="h-4 bg-gradient-to-r from-slate-700 to-transparent rounded-full w-1/4 animate-pulse"></div>
                    <div className="flex gap-3">
                        <div className="h-10 bg-gradient-to-r from-slate-700 to-transparent rounded-lg w-20 animate-pulse"></div>
                        <div className="h-10 bg-gradient-to-r from-slate-700 to-transparent rounded-lg w-24 animate-pulse"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);